import { SPORTS, type Sport } from '@rfqsports/shared';

// 'all' is the sentinel for the lobby's no-sport-filter state. SportKey is
// used by query-string parsing and the sidebar; Sport is what the matched-game
// data actually carries.
export type SportKey = Sport | 'all';

// Display labels for each sport. Record<Sport, …> forces a compile-time
// failure if a new sport is added to SPORTS without a label here.
export const SPORT_LABEL: Record<Sport, string> = {
  nfl: 'NFL',
  nba: 'NBA',
  mlb: 'MLB',
};

// Sidebar emoji per sport. Same Record-typed shape so we can't silently
// fall through to the wrong icon for a new sport.
export const SPORT_ICON: Record<Sport, string> = {
  nfl: '🏈',
  nba: '🏀',
  mlb: '⚾',
};

// Single source of truth for the lobby's `?sport=...` query-string parser.
// Both sport-sidebar.tsx and lobby.tsx import this so they can't drift apart.
export function parseSportFilter(v: string | null): SportKey | null {
  if (v === 'all') return 'all';
  return (SPORTS as readonly string[]).includes(v ?? '') ? (v as Sport) : null;
}
